import React from 'react';

const CircularProgress = ({ 
  percentage = 0, 
  color = '#7D4BC5', 
  size = 40,
  trailColor = '#D2DAE9'
}) => {
  const radius = 46;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="dashboard_progress-bar d-flex align-items-end">
      <svg 
        className="CircularProgressbar" 
        width={size} 
        height={size} 
        viewBox="0 0 100 100"
        data-test-id="CircularProgressbar"
      >
        <path 
          className="CircularProgressbar-trail" 
          d="M 50,50 m 0,-46 a 46,46 0 1 1 0,92 a 46,46 0 1 1 0,-92" 
          strokeWidth="8" 
          fillOpacity="0"
          style={{ 
            stroke: trailColor, 
            strokeDasharray: `${circumference}px, ${circumference}px`, 
            strokeDashoffset: '0px' 
          }}
        />
        <path 
          className="CircularProgressbar-path" 
          d="M 50,50 m 0,-46 a 46,46 0 1 1 0,92 a 46,46 0 1 1 0,-92" 
          strokeWidth="8" 
          fillOpacity="0"
          style={{ 
            stroke: color, 
            strokeDasharray: `${circumference}px, ${circumference}px`, 
            strokeDashoffset: `${strokeDashoffset}px` 
          }}
        />
      </svg>
    </div>
  );
};

export default CircularProgress;

